const menuItems = [
    { name: 'Home', to: '/' },
    { name: 'About', to: '/about' },
    { name: 'Project', to: '/projects' },
    { name: 'Become Volunteer', to: '/become-volunteer' },
    { name: 'Contact', to: '/contact' },
  ];
  module.exports = menuItems;